export const updateHistoryAllowed = [
  'acostantini@tugruero.io',
  'achacin+1@tugruero.io',
  'jetrias+3@tugruero.io',
  'rgonzalez@tugruero.io',
  'jetrias+3@gmail.com',
  'dmorao@tugruero.io',
];
